import { useEffect } from "react";

import { getToken, onMessage } from "firebase/messaging";
import { getMessagingIfSupported } from "../../services/firebase";
import { config } from "../../config";
import { updatePushToken } from "../../utils/notifications";
import { useSelector } from "react-redux";

const PushNotification = () => {

    const { user } = useSelector((state) => state.user);


    useEffect(() => {
        if (!user) return;
        if (typeof Notification === "undefined") return;

        let unsubscribe = () => {};
        let cancelled = false;

        (async () => {
            const messaging = await getMessagingIfSupported();
            if (!messaging || cancelled) return;

            try {
                const permission = await Notification.requestPermission();
                if (permission === "granted") {
                    const token = await getToken(messaging, { vapidKey: config.PUSH_NOTIFICATION_VAPID_KEY_PAIR_ID });
                    updatePushToken({ pushToken: token });
                }
            } catch (error) {
                console.error("Push notification error:", error);
            }

            unsubscribe = onMessage(messaging, (payload) => {
                new Notification(payload.notification.title, {
                    body: payload.notification.body,
                    icon: payload.notification.icon,
                });
            });
        })();

        return () => {
            cancelled = true;
            unsubscribe();
        };
    }, [user]);

    return null;
};

export default PushNotification;
